const Card = ({ children, className = "" }) => (
  <div
    className={`rounded-[16px] bg-background-surface shadow-[0_4px_24px_0_rgba(0,0,0,0.08)] ${className}`}
  >
    {children}
  </div>
);

export default Card;
